var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFtmServicesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.832,
    height: 44.832,
    viewBox: "0 0 44.832 44.832",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "memory_24dp_5F6368_FILL0_wght300_GRAD0_opsz24",
    d: "M164.869-781.577v-13.554h13.554v13.554Zm4.066-4.066h5.422v-5.422h-5.422Zm-4.744,19.705v-4.8h-5.265a4.73,4.73,0,0,1-3.477-1.423,4.73,4.73,0,0,1-1.423-3.477V-780.9h-4.8v-4.066h4.8v-6.777h-4.8v-4.066h4.8v-5.265a4.73,4.73,0,0,1,1.423-3.477,4.73,4.73,0,0,1,3.477-1.423h5.265v-4.8h4.066v4.8h6.777v-4.8H179.1v4.8h5.265a4.73,4.73,0,0,1,3.477,1.423,4.73,4.73,0,0,1,1.423,3.477v5.265h4.8v4.066h-4.8v6.777h4.8v4.066h-4.8v5.265a4.73,4.73,0,0,1-1.423,3.477,4.73,4.73,0,0,1-3.477,1.423H179.1v4.8h-4.066v-4.8h-6.777v4.8Zm20.174-8.862a.8.8,0,0,0,.573-.261.8.8,0,0,0,.261-.573v-25.439a.8.8,0,0,0-.261-.573.8.8,0,0,0-.573-.261H158.926a.8.8,0,0,0-.573.261.8.8,0,0,0-.261.573v25.439a.8.8,0,0,0,.261.573.8.8,0,0,0,.573.261ZM171.646-788.354Z",
    transform: "translate(-149.23 810.77)",
    fill: "#1447b2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtmServicesIcon);
export default __webpack_public_path__ + "static/media/ftm_services_icon.9d8a02bb3ce12d696e07514e20cbd770.svg";
export { ForwardRef as ReactComponent };